export default __webpack_public_path__ + "static/media/google-cast.802a8c47.svg";